import React from "react";
import RoamingItemsList from "./RoamingItemsList/RoamingItemsList";

const RoamingItems: React.FC = () => {
  return <RoamingItemsList />
};
export default RoamingItems;
